import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const CampaignStatusKeys = new Set(['campaigns.status'])

export const isCampaignStatusWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  CampaignStatusKeys.has(filterItem.key)
